import { BpostShippingLabelClient } from '@frontend/bpost/api';
import { ErrorHandler } from '@frontend/error-handler';
import { useEffect, useRef, useState } from 'react';

import { PreviewPDFProps } from './preview-pdf.component';

export const usePreviewPDF = (props: PreviewPDFProps) => {
    const [content, setContent] = useState<string | null>(null);
    const [error, setError] = useState<boolean>(false);
    const fetchStartedRef = useRef<boolean>(false);

    useEffect(() => {
        if (fetchStartedRef.current) return;
        fetchStartedRef.current = true;

        BpostShippingLabelClient.previewShippingLabelPDF(props.barcode.account_id, props.barcode.id)
            .then((response) => {
                setContent(URL.createObjectURL(new Blob([response], { type: 'application/pdf' })));
            })
            .catch((err) => {
                ErrorHandler.handleError({ error: err });
                setError(true);
            });
    }, [props.barcode]);

    useEffect(() => {
        if (!content) return;
        return () => URL.revokeObjectURL(content);
    }, [content]);

    return { content, error };
};
